import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import AuthLayout from '../layout/AuthLayout';
import { LogoRenderer } from '../shared/Logo';

export default function RegisterSuccess() {

    return (
        <AuthLayout>
            <Container component="main" maxWidth="xs" style={{height: '500px'}}>
            <CssBaseline />
            <Box
                sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                }}
            >      
                <LogoRenderer /> 
                <Typography component="h1" variant="h5" display="flex" alignItems="center">
                Information 
                    <Avatar sx={{ m: 1, bgcolor: '#279989' }}>
                        <InfoIcon />
                    </Avatar>
                </Typography>                   
                <div>
                    <p>Page Not Found</p>
                </div>
            </Box>
            </Container>

        </AuthLayout>
    );
}